import { createRouter, createWebHistory } from 'vue-router';
import { ElMessage } from 'element-plus';
import Consent from '@/views/Consent.vue';
import Survey from '@/components/Survey.vue';
import Qianming from '@/components/Qianming.vue';
import Qianming01 from '@/components/Qianming01.vue';
import Bingli from '@/views/Bingli.vue';
import Xinxi from '@/views/Xinxi.vue';
import Denglu from '@/views/Denglu.vue';
import Yishengshenhe from '@/views/Yishengshenhe.vue';
import ApplicationDetail from '@/views/ApplicationDetail.vue';
// 补充导入学生全局Token的操作方法
import { setToken, getToken, getGlobalToken } from '@/utils/auth';
import store from '@/store';

// 1. 定义路由规则
const routes = [
  {
    path: '/',
    redirect: '/denglu'
  },
  {
    path: '/denglu',
    name: 'Denglu',
    component: Denglu,
    meta: {
      requiresAuth: false,
      isLoginPage: true // 标记为登录页，特殊处理
    }
  },
  {
    path: '/survey',
    name: 'Survey',
    component: Survey,
    meta: {
      requiresAuth: true,
      roles: ['student'] // 仅学生可访问
    }
  },
  {
    path: '/qianming',
    name: 'Qianming',
    component: Qianming,
    meta: { requiresAuth: true }
  },
  {
    path: '/qianming01',
    name: 'Qianming01',
    component: Qianming01,
    meta: { requiresAuth: true }
  },
  {
    path: '/bingli',
    name: 'Bingli',
    component: Bingli,
    meta: { requiresAuth: true }
  },
  {
    path: '/xinxi',
    name: 'Xinxi',
    component: Xinxi,
    meta: { requiresAuth: true }
  },
  {
    path: '/consent',
    name: 'Consent',
    component: Consent,
    meta: { requiresAuth: true }
  },
  {
    path: '/yishengshenhe',
    name: 'Yishengshenhe',
    component: Yishengshenhe,
    meta: {
      requiresAuth: true,
      roles: ['doctor'] // 仅医生可访问
    }
  },
  {
    path: '/applicationDetail',
    name: 'ApplicationDetail',
    component: ApplicationDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/denglu'
  }
];

// 2. 创建 router 实例
const router = createRouter({
  history: createWebHistory(), // 使用 history 模式
  routes // 应用路由规则
});

// 路由守卫：修复登录页不需要Token的核心逻辑
router.beforeEach((to, from, next) => {
  // 1. 提取URL中的hopId并存储（可选，保留原有逻辑）
  const hopId = to.query.hopId || from.query.hopId;
  if (hopId) {
    localStorage.setItem('hopId', hopId);
    console.log('路由守卫中获取hopId:', hopId);
  }

  // 2. 处理登录页：完全放行，不校验任何Token，也不自动跳转
  if (to.meta.isLoginPage) {
    next();
    return; // 终止后续逻辑，确保登录页不受任何鉴权影响
  }

  // 3. 处理不需要鉴权的路由（非登录页）
  if (!to.meta.requiresAuth) {
    next();
    return;
  }

  // 4. 处理需要鉴权的路由：区分学生/医生Token，增加容错
  let userInfo = {};
  try {
    userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  } catch (e) {
    console.error('userInfo 解析失败:', e);
    userInfo = {};
  }
  const userRoles = userInfo.role ? [userInfo.role] : store.getters.userRoles || [];
  // 分别获取学生全局Token和医生Token
  const studentToken = getGlobalToken();
  const doctorToken = getToken();

  console.log('学生Token:', studentToken);
  console.log('医生Token:', doctorToken);
  console.log('用户角色:', userRoles);
  console.log('目标路径:', to.path);

  // 5. Token校验：根据访问页面的角色要求，校验对应Token
  let hasValidToken = false;
  if (to.meta.roles?.includes('student')) {
    // 学生页面：校验学生全局Token
    hasValidToken = !!studentToken;
  } else if (to.meta.roles?.includes('doctor')) {
    // 医生页面：校验医生Token
    hasValidToken = !!doctorToken;
  } else {
    // 其他需要鉴权的页面：学生/医生Token任一存在即可
    hasValidToken = !!studentToken || !!doctorToken;
  }

  // 6. 无有效Token：跳回登录页，提示用户
  if (!hasValidToken) {
    ElMessage.warning('请先完成认证/登录');
    next('/denglu');
    return;
  }

  // 7. 角色权限校验：避免无限跳转
  if (to.meta.roles && to.meta.roles.length > 0) {
    const hasPermission = to.meta.roles.some(role => userRoles.includes(role));
    if (!hasPermission) {
      ElMessage.error('无权限访问该页面，将跳转到您的首页');
      // 根据Token类型跳转到对应首页
      const homePath = userRoles.includes('doctor') ? '/yishengshenhe' : '/survey';
      // 防止跳转到自身导致循环
      if (to.path !== homePath) {
        next(homePath);
      } else {
        next(false);
      }
      return;
    }
  }

  // 8. 所有校验通过，正常放行
  next();
});

// 4. 导出 router 实例
export default router;